import {
  alpha,
  darken,
  defaultVariantColorsResolver,
  lighten,
  VariantColorsResolver,
} from "@mantine/core"

export const variantColorResolver: VariantColorsResolver = (input) => {
  const defaultResolvedColors = defaultVariantColorsResolver(input)

  //--------- PRIMARY VARIANT ------------ //
  if (input.variant === "primary") {
    return {
      background: "var(--mantine-color-primary-4)",
      hover: darken("var(--mantine-color-primary-4)", 0.1),
      border: "none",
      color: "var(--mantine-color-white)",
    }
  }

  //--------- PRIMARY CRITICIAL VARIANT ------------ //
  if (input.variant === "primary-critical") {
    return {
      background: "var(--mantine-color-red-8)",
      hover: "var(--mantine-color-red-9)",
      color: "var(--mantine-color-white)",
      border: "none",
      textDecoration: "underline",
    }
  }

  //--------- SECODNARy VARIANT ------------ //
  if (input.variant === "secondary") {
    return {
      background: "var(--mantine-color-primary-0)",
      hover: "var(--mantine-color-primary-1)",
      color: "var(--mantine-color-primary-8)",
      border: "none",
    }
  }

  //--------- SECODNARy VARIANT ------------ //
  if (input.variant === "secondary-critical") {
    return {
      background: "var(--mantine-color-red-0)",
      hover: "var(--mantine-color-red-1)",
      color: "var(--mantine-color-red-8)",
      border: "none",
    }
  }

  //----------------- TERTIARY VARIANT ----------------- //
  if (input.variant === "tertiary") {
    return {
      background: "transparent",
      border: "none",
      hover: "none",
      hoverColor: "var(--mantine-color-primary-6)",
      color: "var(--mantine-color-primary-4)",
    }
  }

  if (input.variant === "tertiary-critical") {
    return {
      background: "transparent",
      hover: "none",
      border: "none",
      hoverColor: "var(--mantine-color-red-9)",
      color: "var(--mantine-color-red-8)",
      textDecoration: "underline",
    }
  }

  if (input.variant === "admin") {
    return {
      background: "var(--mantine-color-violet-1",
      hover: "var(--mantine-color-violet-2)",
      color: "var(--mantine-color-violet-6)",
      border: "none",
    }
  }

  if (input.variant === "admin-tertiary") {
    return {
      background: "transparent",
      hover: "var(--mantine-color-violet-0)",
      color: "var(--mantine-color-violet-6)",
      border: "none",
      textDecoration: "underline",
    }
  }

  if (input.variant === "input-variant") {
    return {
      border: "1px solid var(--input-border-color)",
      background: "var(--mantine-color-white)",
      color: "var(--input-text-color)",
      hover: "var(--mantine-color-gray-0)",
      textDecoration: "underline",
    }
  }

  if (input.variant === "info") {
    return {
      background: alpha("var(--tag-color-info)", 0.1),
      hover: darken("var(--tag-color-info)", 0.1),
      color: "var(--mantine-color-ground-8)",
      border: "none",
    }
  }

  if (input.variant === "info-blue") {
    return {
      background: "var(--mantine-color-secondary-7)",
      hover: darken("var(--mantine-color-secondary-6)", 0.2),
      color: "var(--mantine-color-white)",
      border: "none",
    }
  }
  if (input.variant === "success") {
    return {
      background: "var(--mantine-color-green-1)",
      hover: "none",
      color: darken("var(--mantine-color-green-9)", 0.3),
      border: "none",
    }
  }

  if (input.variant === "warning") {
    return {
      background: "var(--mantine-color-orange-1)",
      hover: "none",
      color: darken("var(--mantine-color-orange-9)", 0.2),
      border: "none",
    }
  }
  if (input.variant === "error") {
    return {
      background: "var(--mantine-color-red-0)",
      hover: "none",
      color: darken("var(--mantine-color-error)", 0.3),
      border: "none",
    }
  }

  if (input.variant === "admin") {
    return {
      background: "var(--mantine-color-purple-0)",
      hover: "var(--mantine-color-purple-2)",
      color: darken("var(--mantine-color-purple-9)", 0.6),
      border: "none",
    }
  }

  if (input.variant === "ghost") {
    return {
      background: "transparent",
      hover: "transparent",
      color: lighten("var(--mantine-color-text-color)", 0.2),
      hoverColor: darken("var(--mantine-color-text-color)", 0.1),
      border: "none",
    }
  }

  return defaultResolvedColors
}
